<template>
  <div id="app">
    <div class="header" style="z-index: 2">
      <div class="grid-x">
        <div class="cell shrink">
          <img src="./assets/toast-header.png" alt="" style="max-width: 200px">
          <!-- <img src="./assets/adi-logo.svg" alt="" style="width: 110px; margin-top: 6px"> -->
        </div>
        <div class="cell auto text-right">
          <award style="width: 29px; height: auto; margin-top: 5px; margin-right: 10px; display: inline-block" />
          <img src="./assets/dummy-account.jpg" alt="" style="cursor: pointer; max-width: 31px; float: right; margin-right: 0.5rem; border-radius: 50%; margin-top: 5px;" @click="showMenu = !showMenu" />
        </div>
      </div>
    </div>
    <div v-if="showMenu" class="grid-x account-menu">
      <div class="cell small-8">
        <div class="grid-x grid-padding-x">
          <div class="cell medium-6 text-center">
            <award style="width: 80px" />
            <p>
              Demonstrated Critical Thinking
            </p>
          </div>
          <div class="cell medium-6 text-center">
            <award style="width: 80px" />
            <p>
              Demonstrated Collaboration
            </p>
          </div>
          <!-- div class="cell medium-6 text-center">
            < award style="width: 80px; opacity: 0.25" />
          </div -->
        </div>
      </div>
      <div class="cell small-4">
        <ul class="vertical menu align-right">
          <li>
            <em>Hi, Jennifer!</em>
          </li>
          <li>
            <a href="https://www.google.com" target="_blank">Settings</a>
          </li>
          <li>
            <hr>
          </li>
          <li>
            Logout
          </li>
        </ul>
      </div>
    </div>
    <!-- div class="menu">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div -->
    <router-view/>
  </div>
</template>

<style lang="scss">
</style>

<script>
  import Award from '@/components/Award.vue'

  // import './scss/site.module.scss';
  export default {
    components: {
      Award
    },
    data() {
      return {
        showMenu: false
      }
    }
  }
</script>